// extracted by mini-css-extract-plugin
export default {"finishedLabel":"FZYj37j3rp2K2vIjo2yK"};